import { useEffect, useState } from "react";
import styled from "styled-components";
import checkecdImg from "../../assets/img/checked.svg";

const SwitchLabel = styled.label`
  position: relative;
  display: inline-block;
  width: 50px;
  height: 25px;

  input[type="checkbox"] {
    display: none;
  }

  .switch {
    position: absolute;
    cursor: pointer;
    background: #eaeef4;
    border: ${(props) =>
      props.disabled === true ? `1px solid lightgray` : `1px solid #7e92a2`};
    border-radius: 12px;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transition: background-color 0.2s ease;
  }
  .switch::before {
    position: absolute;
    content: "";
    left: 2px;
    top: 3px;
    width: 16px;
    height: 16px;
    background-color: #aaa;
    border-radius: 50%;
    transition: transform 0.3s ease;
  }
  input[type="checkbox"]:checked + .switch::before {
    transform: translateX(25px);
    top: 2px;
    width: 20px;
    height: 20px;
    background: url(${checkecdImg}) no-repeat center center white;
  }

  input[type="checkbox"]:checked + .switch {
    background: #514ef3;
    border-radius: 12px;
  }
`;

function ToggleSwitch({
  toggled = false,
  onToggle,
  disabled,
  name,
  value,
  checked,
}) {
  const [isToggled, setIsToggled] = useState(checked ?? toggled);

  useEffect(() => {
    setIsToggled(checked ?? toggled);
  }, [checked, toggled]);

  const handleToggle = async (event) => {
    const next = !isToggled;
    setIsToggled(next);
    const result = await onToggle?.(event, next);
    if (result === false) {
      setIsToggled(!next);
    }
  };

  const isChecked = typeof checked === "boolean" ? checked : isToggled;

  return (
    <SwitchLabel disabled={disabled} name={name}>
      <input
        name={name}
        disabled={disabled}
        id="toggle-switch"
        type={"checkbox"}
        value={value}
        checked={isChecked}
        onChange={handleToggle}
        onClick={(e) => e.stopPropagation()}
      />
      <span className="switch" onClick={(e) => e.stopPropagation()} />
    </SwitchLabel>
  );
}
export default ToggleSwitch;
